export enum OrganizationType {
  Isd = 'ISD',
  District = 'District',
}
